import { components } from "react-select";
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import { XIcon } from "@heroicons/react/outline";

const MultiValue = (props: any) => {
  const { components, data, selectProps, removeProps } = props;
  const { Label } = components;

  return (
    <Label
      data={data}
      selectProps={selectProps}
      innerProps={{
        // this prevents the menu from being opened/closed when the user clicks on a value to begin dragging it.
        onMouseDown: (e: any) => {
          e.preventDefault();
          e.stopPropagation();
        },
      }}
    >
      <span className="bg-gray-200 px-2 py-1 rounded-full text-sm inline-flex items-center gap-1 leading-none mr-1 mt-1 mb-1">
        {props.children}
        <XIcon className="w-3 h-3 cursor-pointer" {...removeProps} />
      </span>
    </Label>
  );
};

export const SortableMultiValue = SortableElement(MultiValue);
export const SortableMultiValueLabel = SortableHandle((props: any) => (
  <components.MultiValueLabel {...props} />
));

export default MultiValue;
